import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { DestinationTypeEnum } from "../../../shared/enums/destination.enum";
import { FormControlNameEnum } from "../../../shared/enums/form-control.enum";
import { CountryCd } from "@xpo-ltl/sdk-common";
import { SelectObject } from "../../../shared/model/select.model";
import { RouteTypeEmum } from "../../../shared/enums/route-type.enum";

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent {
  countries: SelectObject<CountryCd>[] = [];
  destTypes: SelectObject<DestinationTypeEnum>[] = [];

  validStateCity: boolean;
  checking: boolean;

  @Input() title: string = '';
  @Input() displayZipOnly: boolean = false;
  @Input() displayStateCity: boolean = false;
  @Input() formGroup: FormGroup;

  constructor() {
    this.countries = Object.values(CountryCd).map((val) => new SelectObject<CountryCd>(this.mapCountryName(val), val));
    this.destTypes.push(new SelectObject<DestinationTypeEnum>('Zip Only', DestinationTypeEnum.ZIP_ONLY));
    this.destTypes.push(new SelectObject<DestinationTypeEnum>('State/City', DestinationTypeEnum.STATE_CITY));
  }

  onSelectZipCode(zipCd): void {
    this.formGroup.get(FormControlNameEnum.ZIP_CD).patchValue(zipCd);
  }

  private mapCountryName(country: string): string {
    return !!country ? country.split(/(?=[A-Z])/).join(' ') : '';
  }
}
